// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { useState } from "react";
// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import Wrecksite from "pages/LandingPages/Locations/EastCoast/sections/wrecksite";
import Reefdives from "pages/LandingPages/Locations/EastCoast/sections/reefdives";

// Material Kit 2 React examples
//import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function Introduction() {
  const [activeSection, setActiveSection] = useState("wreck");
  return (
    <MKBox component="section" py={8}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={50} md={32}>
            <Grid container justifyContent="flex-start">
              <MKTypography variant="body1" mt={1} mb={0}>
                From May to October, Sri Lanka’s East Coast transforms into a diver’s paradise. With
                calm seas and crystal-clear visibility, this season offers the best conditions to
                explore vibrant coral reefs, swim with reef sharks and rays, and discover
                fascinating wrecks hidden beneath the surface. Trincomalee and Passikudah are the
                highlights of the East Coast, known for their rich marine biodiversity and stunning
                dive sites. Whether you’re a beginner or an experienced diver, the East Coast season
                promises warm waters, breathtaking underwater life, and unforgettable adventures.
              </MKTypography>
            </Grid>
          </Grid>
        </Grid>
      </Container>
      <Container>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} lg={12}>
            <MKTypography variant="body1" mt={4} mb={0}>
              <strong>
                At our Kayankerni & Passikudah Dive Sites with different depth from 6 to 30 m we
                offer{" "}
                <span
                  onClick={() => setActiveSection("wreck")}
                  style={{
                    cursor: "pointer",
                    color: activeSection === "wreck" ? "#d32f2f" : "#1976d2",
                    textDecoration: "underline",
                  }}
                >
                  Wreck Dives
                </span>{" "}
                and{" "}
                <span
                  onClick={() => setActiveSection("reef")}
                  style={{
                    cursor: "pointer",
                    color: activeSection === "reef" ? "#d32f2f" : "#1976d2",
                    textDecoration: "underline",
                  }}
                >
                  Reef Dives
                </span>
                .
              </strong>
            </MKTypography>
          </Grid>
        </Grid>
      </Container>
      <Container>
        {activeSection === "wreck" && <Wrecksite />}
        {activeSection === "reef" && <Reefdives />}
      </Container>
    </MKBox>
  );
}

export default Introduction;
